import React, { useState, useEffect } from "react";
import API from '../api/index';

function PortfolioItem(item){
	var imageSrc = 'images/portfolio-1.jpg';
	if(item.Attachments){
		imageSrc = item.Attachments[0]['url'];
	}
	var title = item.Title;
	var description = item.Description;
	var url = item.Link;
	var status = item.Status;
	return(
		<div className="col-md-4">
			<a className="portfolio-item" rel="noreferrer" target="_blank" href={url} style={{backgroundColor:'#fff'}}>
				<div className="portfolio-thumb">
					<img srcSet={imageSrc} className="img-responsive" alt="" />
				</div>

				<div className="portfolio-info">
					<h3>{title}</h3>
					<small>{description}</small><br/>
					<small className={`badge ${status=='Completed'?'badge-success':'badge-warning'}`}>{status}</small>
				</div>
			</a>
		</div>
	)
}

function Portfolio(){
	const [portfolioData, setPortfolioData] = useState([]);
	let count = 1;

	useEffect(() => {
		let portfolioData = API.getPortfolio();
		portfolioData.then(
			response => {
				console.log(response.records);
				setPortfolioData(response.records)
			}
		);
	}, [count]);

	return(
		<section className="section-wrapper portfolio-section gray-bg">
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<div className="section-title">
							<h2>Portfolio</h2>
						</div>
					</div>
				</div>
				<div className="row">
					{
						portfolioData	?	
							portfolioData.map((item,index) => 
								PortfolioItem(item.fields)
							)
						:	<></>
					}
				</div>
			</div>
		</section>
	)
}

export default Portfolio;